/** Presentation of the run's own numbers. The view model keeps them raw. */

const SECONDS_PER_MINUTE = 60;

/** Three significant figures, which is how the design shows 4.55M and 23.5K. */
const significant = new Intl.NumberFormat("en-US", {
  maximumSignificantDigits: 3,
});

/** 553.5 -> "9 min 14 s". Rounds to the second before splitting. */
export const formatRunDuration = (seconds: number): string => {
  const whole = Math.round(seconds);
  const minutes = Math.floor(whole / SECONDS_PER_MINUTE);
  const remainder = whole % SECONDS_PER_MINUTE;

  if (minutes === 0) {
    return `${remainder} s`;
  }

  return `${minutes} min ${remainder} s`;
};

/** 4553870 -> "4.55M", 23543 -> "23.5K". */
export const formatTokenCount = (tokens: number): string => {
  if (tokens >= 1_000_000) {
    return `${significant.format(tokens / 1_000_000)}M`;
  }

  if (tokens >= 1_000) {
    return `${significant.format(tokens / 1_000)}K`;
  }

  return significant.format(tokens);
};

const localClockTime = new Intl.DateTimeFormat("en-US", {
  hour: "numeric",
  minute: "2-digit",
  timeZoneName: "short",
});

/** A run's start in the reader's own zone, labelled: "1:12 PM CDT". */
export const formatRunStartTime = (startedAt: Date): string =>
  localClockTime.format(startedAt);
